const HTTPS_API_ORIGIN = "https://api.elevenlabs.io";
export function postOverallFeedback(conversationId, likeOrFeedback, origin = HTTPS_API_ORIGIN) {
    const body = {};
    if (typeof likeOrFeedback === "boolean") {
        body.feedback = likeOrFeedback ? "like" : "dislike";
    }
    else {
        body.rating = likeOrFeedback.rating;
        body.comment = likeOrFeedback.comment;
    }
    return fetch(`${origin}/v1/convai/conversations/${conversationId}/feedback`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
        },
    });
}
//# sourceMappingURL=postOverallFeedback.js.map